module.exports = __webpack_public_path__ + "img/7_hillstate.a906a510.png";